export async function wait(time: number): Promise<void> {
	// eslint-disable-next-line promise/avoid-new
	return new Promise((resolve) => {
		setTimeout(resolve, time);
	});
}
